<template>

<div>

	<input type="checkbox" v-on:change="check()" v-model="checkbox" />

</div>

</template>


<script>
    export default {
        props: {
	        type: {},
	        currentData: {}
	    },
	    data: function() {

            return {

                checkbox: (this.currentData.value == 1 ? true : false)
               
            }

        },
	    methods: {
	 
	    	check: function() {

	    		bus.$emit('checkbox-changed', this.type, this.checkbox)


	    	}

	    },
	    watch: {

	    	currentData: function() {
	    		//this.checkbox = this.currentData.value;
	    	}

	    }

    }
</script>